import * as React from 'react';

import styles from './FatInfoBlock.css';
import { IFatInfrastructureListItem } from '../../types';

export function FatInfoBlock({ title, description, iconUrl, imageUrl }: IFatInfrastructureListItem) {
  return (
    <li className={styles['container']}>
      <div className={styles['content_container']}>
        <div className={styles['header']}>
          <div className={styles['header-icon']}>
            <img src={iconUrl} alt={title} />
          </div>
          <strong className={styles['header-title']}>{title}</strong>
        </div>
        <p className={styles['description']}>{description}</p>
      </div>
      <div className={styles['image_container']}>
        <img src={imageUrl} alt={title} />
      </div>
    </li>
  );
}
